








// Composition
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  name: 'Reactivity',

  props: {
    reactivity: {
      type: Array as () => Array<string>,
      required: true,
    },
  },
})
